import { useState } from "react";
import { DevAgentChatMessageContent } from "../../chat/DevAgentChatMessageContent";
import { useDevAgentStore, type FeedItem as FeedItemT } from "@/stores/devAgentStore";
import { messageHasTableOrFence } from "./chatRichContent";

const intentMarkdownClass =
  "[&_table]:text-[11px] [&_th]:px-2 [&_th]:py-0.5 [&_td]:px-2 [&_td]:py-0.5";

export function IntentConfirmCard({
  item,
  onSendMessage,
}: {
  item: FeedItemT;
  onSendMessage?: (msg: string) => void;
}) {
  const [status, setStatus] = useState<"pending" | "approved" | "rejected">(
    "pending",
  );
  const content = item.data.content || "";
  const rich = messageHasTableOrFence(content);

  return (
    <div className="py-2">
      <div className="rounded-xl border border-primary/20 bg-primary/5 px-4 py-3 max-w-[90%] shadow-sm">
        <div className="text-[10px] text-muted-foreground/85 uppercase tracking-wide mb-2">
          Review & Send
        </div>
        <div className="text-sm mb-3">
          {rich ? (
            <DevAgentChatMessageContent content={content} className={intentMarkdownClass} />
          ) : (
            content
          )}
        </div>
        {status === "pending" && (
          <div className="flex gap-2">
            <button
              type="button"
              onClick={() => {
                setStatus("approved");
                void Promise.resolve(onSendMessage?.(content))
                  .then(() => {
                    useDevAgentStore.getState().removeFeedItem(item.id);
                  })
                  .catch(() => {
                    setStatus("pending");
                  });
              }}
              className="px-3 py-1.5 text-xs font-medium rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
            >
              Send to Agent
            </button>
            <button
              type="button"
              onClick={() => {
                setStatus("rejected");
                useDevAgentStore.getState().removeFeedItem(item.id);
              }}
              className="px-3 py-1.5 text-xs font-medium rounded-lg border border-border hover:bg-muted/50 text-muted-foreground transition-colors"
            >
              Dismiss
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
